import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b11c30c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "link link--nonstyled info-icon"
};
const _hoisted_2 = {
    key: 1,
    class: "search-bar__input__tag-set-wrapper"
};
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = { class: "search-bar__controls" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-search search-bar__controls__search-icon" }, null, -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-tag" }, null, -1 /* HOISTED */));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = {
    key: 0,
    class: "search-bar__popover"
};
const _hoisted_9 = { class: "search-bar__popover__section" };
import { map } from "lodash";
import { ref, computed, useSlots } from "vue";
import { onClickOutside } from "@vueuse/core";
import TagSet from "../tags/TagSet.vue";
import { useDebounceFn } from "@vueuse/core";
import VerticalScroll from "../VerticalScroll.vue";
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
import TagSetMultiSelect from "src/shared/v-components/ui/form/TagSetMultiSelect.vue";
import { useDrawerTriggerStore } from "src/shared/v-components/ui/drawer/drawer-trigger/index";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchBar',
    props: {
        tags: {},
        search: {},
        tagSuggestions: {},
        placeholder: { default: "Search" },
        additionalIcon: {}
    },
    emits: ["update:tags", "update:search", "additional-icon-click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const slots = useSlots();
        const drawerTriggerStore = useDrawerTriggerStore();
        const hasTagSuggestions = () => {
            return !!props.tagSuggestions && !!isTagsMode.value;
        };
        const hasPopoverContent = computed(() => {
            return !!slots.preview || hasTagSuggestions();
        });
        const isInteracting = ref(false);
        const tagInput = ref("");
        const emit = __emit;
        const tagsProxy = computed({
            get() {
                return props.tags || [];
            },
            set(value) {
                if (value) {
                    tagInput.value = "";
                    emit("update:tags", value);
                }
            },
        });
        const searchProxy = computed({
            get() {
                return props.search;
            },
            set: useDebounceFn((value) => {
                if (value !== undefined) {
                    emit("update:search", value);
                }
            }, 500),
        });
        const el = ref(null);
        const bar = ref(null);
        const searchInput = ref(null);
        const isFocusedTagSet = ref(false);
        const startInteracting = () => {
            isInteracting.value = true;
        };
        const stopInteracting = () => {
            if (drawerTriggerStore.state.drawerTriggerWorkflow.isOpen) {
                return;
            }
            isInteracting.value = false;
        };
        onClickOutside(bar, stopInteracting);
        const isTagsMode = ref(false);
        const toggleTagsMode = () => {
            isTagsMode.value = !isTagsMode.value;
        };
        const searchBarInputStyle = computed(() => {
            if (isTagsMode.value) {
                return {
                    overflow: "scroll",
                };
            }
            return {};
        });
        const allTagOptions = computed(() => {
            return map(props.tagSuggestions, (tag) => {
                return {
                    displayName: tag,
                    value: tag,
                };
            });
        });
        const filteredTagOptions = computed(() => {
            return useFuzzySearch(tagInput.value, allTagOptions.value, ["value"]);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "form",
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["prevent"]))
            }, [
                _createElementVNode("div", {
                    class: "search-bar-v2",
                    onClick: startInteracting,
                    ref_key: "bar",
                    ref: bar
                }, [
                    _createElementVNode("span", {
                        class: "search-bar__input",
                        style: _normalizeStyle(searchBarInputStyle.value),
                        ref_key: "el",
                        ref: el
                    }, [
                        (_ctx.additionalIcon)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
                                _createElementVNode("i", {
                                    class: _normalizeClass([_ctx.additionalIcon, "search-bar__controls__search-icon"]),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('additional-icon-click')))
                                }, null, 2 /* CLASS */)
                            ]))
                            : _createCommentVNode("v-if", true),
                        (isTagsMode.value && tagsProxy.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                _createVNode(TagSet, {
                                    class: "search-bar__input__tag-set-wrapper__tag-set",
                                    tags: tagsProxy.value,
                                    "onUpdate:tags": _cache[1] || (_cache[1] = ($event) => ((tagsProxy).value = $event)),
                                    "is-focused": isFocusedTagSet.value,
                                    "onUpdate:isFocused": _cache[2] || (_cache[2] = ($event) => ((isFocusedTagSet).value = $event)),
                                    "tag-input": tagInput.value,
                                    "onUpdate:tagInput": _cache[3] || (_cache[3] = ($event) => ((tagInput).value = $event))
                                }, null, 8 /* PROPS */, ["tags", "is-focused", "tag-input"])
                            ]))
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 2,
                                type: "text",
                                ref_key: "searchInput",
                                ref: searchInput,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((searchProxy).value = $event)),
                                placeholder: _ctx.placeholder,
                                class: _normalizeClass({
                                    'with-info': _ctx.additionalIcon !== undefined,
                                }),
                                onKeydown: _withKeys(stopInteracting, ["esc"]),
                                onFocus: startInteracting
                            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3)), [
                                [_vModelText, searchProxy.value]
                            ])
                    ], 4 /* STYLE */),
                    _createElementVNode("span", _hoisted_4, [
                        _hoisted_5,
                        (_ctx.tags)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass(["button button--transparent", { active: isTagsMode.value }]),
                                onClick: toggleTagsMode
                            }, _hoisted_7, 2 /* CLASS */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    (isInteracting.value && hasPopoverContent.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(VerticalScroll, { "max-height": '400px' }, {
                                    default: _withCtx(() => [
                                        _renderSlot(_ctx.$slots, "preview")
                                    ]),
                                    _: 3 /* FORWARDED */
                                }),
                                _createElementVNode("div", null, [
                                    (_ctx.tags)
                                        ? (_openBlock(), _createBlock(TagSetMultiSelect, {
                                            key: 0,
                                            tags: tagsProxy.value,
                                            "onUpdate:tags": _cache[5] || (_cache[5] = ($event) => ((tagsProxy).value = $event)),
                                            options: filteredTagOptions.value.value
                                        }, null, 8 /* PROPS */, ["tags", "options"]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ], 512 /* NEED_PATCH */)
            ], 32 /* NEED_HYDRATION */));
        };
    }
});
